// Simple Shopify Theme JavaScript

// Document ready function
document.addEventListener('DOMContentLoaded', function () {
	initQuantitySelectors()
	initCartDrawer()
	initCartAgreement()
	initAjaxCart()
	initMobileMenu()
	initLanguageSwitcher()
	initAccordions()

	// Header scroll effect
	window.addEventListener('scroll', handleHeaderScroll)
})

// Initialize quantity selectors on product pages
function initQuantitySelectors() {
	const quantitySelectors = document.querySelectorAll('.quantity-selector')

	if (!quantitySelectors.length) return

	quantitySelectors.forEach(selector => {
		const input = selector.querySelector('input')
		const increaseBtn = selector.querySelector('.increase')
		const decreaseBtn = selector.querySelector('.decrease')

		if (increaseBtn) {
			increaseBtn.addEventListener('click', function () {
				input.value = parseInt(input.value) + 1
			})
		}

		if (decreaseBtn) {
			decreaseBtn.addEventListener('click', function () {
				const newValue = parseInt(input.value) - 1
				input.value = newValue > 0 ? newValue : 1
			})
		}
	})
}

// Initialize Cart Drawer
function initCartDrawer() {
	const cartDrawer = document.getElementById('cart-drawer')
	const cartDrawerOverlay = document.getElementById('cart-drawer-overlay')
	const cartDrawerTrigger = document.querySelector('.cart-drawer-trigger')
	const cartDrawerClose = document.querySelector('.cart-drawer-close')

	if (
		!cartDrawer ||
		!cartDrawerOverlay ||
		!cartDrawerTrigger ||
		!cartDrawerClose
	)
		return

	// Open cart drawer
	cartDrawerTrigger.addEventListener('click', function (e) {
		if (document.getElementById('cart-form')) {
			e.preventDefault()
			e.preventDefault()
			location.reload()
			return
		}

		e.preventDefault()
		openCartDrawer()
	})

	// Close cart drawer with close button
	cartDrawerClose.addEventListener('click', closeCartDrawer)

	// Close cart drawer with overlay
	cartDrawerOverlay.addEventListener('click', closeCartDrawer)

	// Handle quantity updates in drawer
	const quantitySelectors = cartDrawer.querySelectorAll('.quantity-selector')
	quantitySelectors.forEach(selector => {
		const input = selector.querySelector('input')
		// const increaseBtn = selector.querySelector('.increase')
		// const decreaseBtn = selector.querySelector('.decrease')

		if (input) {
			input.addEventListener('change', function () {
				updateCartFromDrawer()
			})
		}
	})

	// Handle drawer remove items
	// const removeButtons = cartDrawer.querySelectorAll(
	// 	'.cart-drawer-item-remove',
	// )
	// removeButtons.forEach(button => {
	// 	button.addEventListener('click', function (e) {
	// 		e.preventDefault()
	// 		const href = this.getAttribute('href')
	//
	// 		// 아이템 제거 시 fetch를 /cart/change.js 엔드포인트로 직접 요청
	// 		const lineItem = href.match(/line=(\d+)/)
	// 		if (lineItem && lineItem[1]) {
	// 			const lineNumber = lineItem[1]
	//
	// 			fetch('/cart/change.js', {
	// 				method: 'POST',
	// 				headers: {
	// 					'Content-Type': 'application/json',
	// 				},
	// 				body: JSON.stringify({
	// 					line: parseInt(lineNumber),
	// 					quantity: 0,
	// 				}),
	// 			})
	// 				.then(response => response.json())
	// 				.then(() => {
	// 					refreshCartDrawer()
	// 					updateCartCount()
	// 				})
	// 				.catch(error => {
	// 					console.error('Error removing item:', error)
	// 					// 에러 발생해도 일단 새로고침
	// 					refreshCartDrawer()
	// 					updateCartCount()
	// 				})
	// 		} else {
	// 			console.error('Invalid line item URL format')
	// 		}
	// 	})
	// })

	// Handle form submission
	const cartForm = cartDrawer.querySelector('.cart-drawer-form')
	if (cartForm) {
		cartForm.addEventListener('submit', function (e) {
			if (e.submitter && e.submitter.name !== 'checkout') {
				e.preventDefault()
				updateCartFromDrawer()
			}
		})
	}
}

// Open cart drawer
function openCartDrawer() {
	const cartDrawer = document.getElementById('cart-drawer')
	const cartDrawerOverlay = document.getElementById('cart-drawer-overlay')

	if (!cartDrawer || !cartDrawerOverlay) return

	cartDrawer.classList.add('active')
	cartDrawerOverlay.classList.add('active')
	document.body.style.overflow = 'hidden'
}

// Close cart drawer
function closeCartDrawer() {
	const cartDrawer = document.getElementById('cart-drawer')
	const cartDrawerOverlay = document.getElementById('cart-drawer-overlay')

	if (!cartDrawer || !cartDrawerOverlay) return

	cartDrawer.classList.remove('active')
	cartDrawerOverlay.classList.remove('active')
	document.body.style.overflow = ''
}

// Update cart from drawer inputs
function updateCartFromDrawer() {
	const cartForm = document.querySelector('.cart-drawer-form')
	if (!cartForm) return

	const formData = new FormData(cartForm)

	fetch('/cart/update.js', {
		method: 'POST',
		body: formData,
	})
		.then(response => response.json())
		.then(() => {
			refreshCartDrawer()
			updateCartCount()
		})
		.catch(error => {
			console.error('Error updating cart:', error)
		})
}

// Refresh cart drawer contents
function refreshCartDrawer() {
	fetch('/?section_id=cart-drawer')
		.then(response => response.text())
		.then(html => {
			const parser = new DOMParser()
			const doc = parser.parseFromString(html, 'text/html')
			const newCartDrawer = doc.querySelector('#cart-drawer')

			if (newCartDrawer) {
				const currentCartDrawer = document.querySelector('#cart-drawer')
				currentCartDrawer.innerHTML = newCartDrawer.innerHTML

				// Reinitialize drawer functionality
				initCartDrawer()
				initCartAgreement()
			}
		})
		.catch(error => {
			console.error('Error refreshing cart drawer:', error)
		})
}

// Initialize Ajax cart functionality
function initAjaxCart() {
	const addToCartForms = document.querySelectorAll('form[action="/cart/add"]')

	if (!addToCartForms.length) return

	addToCartForms.forEach(form => {
		form.addEventListener('submit', function (e) {
			e.preventDefault()

			const formData = new FormData(form)

			fetch('/cart/add.js', {
				method: 'POST',
				body: formData,
			})
				.then(response => response.json())
				.then(() => {
					updateCartCount()
					showCartNotification('Item added to cart')
					// Open cart drawer after adding item
					openCartDrawer()
					refreshCartDrawer()
				})
				.catch(error => {
					console.error('Error adding to cart:', error)
					showCartNotification('Error adding to cart', true)
				})
		})
	})
}

// Update cart count in header
function updateCartCountValue(count) {
	const cartCountElements = document.querySelectorAll('.cart-count')
	cartCountElements.forEach(el => {
		el.textContent = count
	})

	document.querySelectorAll('[data-cart-count]').forEach(el => {
		el.setAttribute('data-cart-count', count)
	})
}

function updateCartCount() {
	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			updateCartCountValue(cart.item_count)
		})
}

// Show cart notification
function showCartNotification(message, isError = false) {
	let notification = document.querySelector('.cart-notification')

	if (!notification) {
		notification = document.createElement('div')
		notification.className = 'cart-notification'
		document.body.appendChild(notification)
	}

	notification.textContent = message
	notification.classList.toggle('error', isError)
	notification.classList.add('active')

	setTimeout(() => {
		notification.classList.remove('active')
	}, 3000)
}

// Initialize mobile menu functionality
function initMobileMenu() {
	if (window.innerWidth < 768) {
		const mainMenuLinks = document.querySelectorAll('.main-menu-link')

		mainMenuLinks.forEach(link => {
			link.addEventListener('click', function (e) {
				const menuItem = this.parentNode
				const submenu = menuItem.querySelector('.submenu')

				if (submenu && !submenu.classList.contains('active')) {
					e.preventDefault()
					submenu.classList.add('active')
					submenu.style.display = 'block'

					// Close when clicking outside
					const closeSubmenu = function (event) {
						if (!menuItem.contains(event.target)) {
							submenu.classList.remove('active')
							submenu.style.display = ''
							document.removeEventListener('click', closeSubmenu)
						}
					}

					setTimeout(() => {
						document.addEventListener('click', closeSubmenu)
					}, 0)
				}
			})
		})
	}
}

// Initialize language switcher
function initLanguageSwitcher() {
	// No custom JS needed for language links - letting the default link behavior work
	// Links are already formatted correctly in theme.liquid
}

// Removing or modifying the filtering function
// function collectionNavigationFiltering() {
// 	// Empty function - no filtering needed
// }

// Header scroll effect
let lastScrollPosition = 0
const scrollThreshold = 50 // 스크롤 거리 임계값

function handleHeaderScroll() {
	const header = document.querySelector('header')
	const currentScrollPosition = window.pageYOffset

	// 스크롤 방향 확인
	if (
		currentScrollPosition > lastScrollPosition &&
		currentScrollPosition > scrollThreshold
	) {
		// 아래로 스크롤: 헤더 숨기기
		header.classList.add('hide')
	} else {
		// 위로 스크롤 또는 최상단 근처: 헤더 보이기
		header.classList.remove('hide')
	}

	lastScrollPosition = currentScrollPosition
}

// Cart agreement checkbox functionality
function initCartAgreement() {
	const agreementCheckbox = document.getElementById('policy-agreement')
	const checkoutButton = document.getElementById('checkout-button')
	const agreementText = document.querySelector('.agreement-text')
	const returnPolicyModal = document.querySelector('.return-policy-modal')
	const modalClose = document.querySelector('.return-policy-modal-close')

	if (agreementCheckbox && checkoutButton) {
		// Ensure checkout button is disabled initially
		checkoutButton.disabled = true

		// Enable/disable checkout button based on checkbox
		agreementCheckbox.addEventListener('change', function () {
			checkoutButton.disabled = !this.checked
		})
	}

	if (agreementText && returnPolicyModal) {
		// Open modal when clicking agreement text
		agreementText.addEventListener('click', function (e) {
			e.preventDefault()
			e.stopPropagation() // Prevent checkbox toggle
			returnPolicyModal.classList.add('active')
			document.body.style.overflow = 'hidden'
		})
	}

	if (modalClose && returnPolicyModal) {
		// Close modal
		modalClose.addEventListener('click', function () {
			returnPolicyModal.classList.remove('active')
			document.body.style.overflow = ''
		})

		// Close modal on background click
		returnPolicyModal.addEventListener('click', function (e) {
			if (e.target === returnPolicyModal) {
				returnPolicyModal.classList.remove('active')
				document.body.style.overflow = ''
			}
		})
	}
}

function initAccordions() {
	const accordions = document.querySelectorAll('.accordion-toggle')

	accordions.forEach(accordion => {
		accordion.addEventListener('change', function () {
			const content = this.nextElementSibling.nextElementSibling
			const contentInner = content.querySelector('div')

			if (this.checked) {
				// Close other accordions
				accordions.forEach(other => {
					if (other !== this && other.checked) {
						other.checked = false
						const otherContent =
							other.nextElementSibling.nextElementSibling
						otherContent.style.height = '0px'
					}
				})

				// Open current accordion
				const height = contentInner.offsetHeight
				content.style.height = height + 'px'
			} else {
				content.style.height = '0px'
			}
		})
	})
}
